const conferenceSummary = (
  <div className="interview-boost-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Understanding Career Conferences & Fairs</h3>
      <ul className="list-disc pl-6">
        <li>
          Career conferences and fairs provide opportunities to meet professionals and recruiters.
        </li>
        <li>They often feature keynote speeches, panel discussions, and networking sessions.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How to Prepare</h3>
      <ul className="list-disc pl-6">
        <li>Research attending companies in advance and tailor your approach.</li>
        <li>Dress professionally and bring multiple copies of your resume.</li>
        <li>Practice a short personal pitch to introduce yourself to recruiters.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Making the Most of These Events</h3>
      <ul className="list-disc pl-6">
        <li>Ask thoughtful questions and engage in meaningful conversations.</li>
        <li>Connect with recruiters on LinkedIn and follow up after the event.</li>
        <li>Take advantage of free workshops and career panels to gain insights.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Networking Benefits</h3>
      <ul className="list-disc pl-6">
        <li>Meeting professionals can lead to job referrals and mentorship opportunities.</li>
        <li>Some companies fast-track applications for candidates they meet at events.</li>
        <li>Attending regularly helps you stay updated on industry trends and opportunities.</li>
      </ul>
    </div>
  </div>
);

export default conferenceSummary;
